<img
    class="car-image"
    *ngFor="let car of carsUrls"
    [src]="'assets/images/model-x/' + car.path + '.jpg'"
    [alt]="car.path"
    [class.active]="car.path === (activePath$ | async)"
/>
<div class="lateral-shadow"></div>
